import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";

function FilterDMKHO({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    kho: "",
    email: "",
    dien_thoai: "",
    dia_chi: "",
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = { $or: [] };
    if (filter.kho) {
      condition.$or.push({
        ma_kho: { $regex: filter.kho?.split(" ")?.join(".*"), $options: "i" },
      });
      condition.$or.push({
        ten_kho: { $regex: filter.kho?.split(" ")?.join(".*"), $options: "i" },
      });
    }
    if (filter.email) {
      condition["exfields.email"] = {
        $regex: filter.email.split(" ").join(".*"),
        $options: "i",
      };
    }
    if (filter.dien_thoai) {
      condition["exfields.dien_thoai"] = {
        $regex: filter.dien_thoai.split(" ").join(".*"),
        $options: "i",
      };
    }
    if (filter.dia_chi) {
      condition.dia_chi = {
        $regex: filter.dia_chi.split(" ").join(".*"),
        $options: "i",
      };
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        direction="column"
        label="Chi nhánh"
        placeholder="Tìm theo mã, tên chi nhánh"
        value={filter.kho}
        onSearch={(val) => setFilter({ ...filter, kho: val })}
      />
      <FilterText
        direction="column"
        label="Email"
        placeholder="Tìm theo email"
        value={filter.email}
        onSearch={(val) => setFilter({ ...filter, email: val })}
      />
      <FilterText
        direction="column"
        label="Điện thoại"
        placeholder="Tìm theo số điện thoại"
        value={filter.dien_thoai}
        onSearch={(val) => setFilter({ ...filter, dien_thoai: val })}
      />
      <FilterText
        direction="column"
        label="Địa chỉ"
        placeholder="Tìm theo địa chỉ"
        value={filter.dia_chi}
        onSearch={(val) => setFilter({ ...filter, dia_chi: val })}
      />
    </WrapperFilter>
  );
}

export default FilterDMKHO;
